import { render, staticRenderFns } from "./callagent.vue?vue&type=template&id=01709dff&scoped=true"
import script from "./callagent.vue?vue&type=script&lang=js"
export * from "./callagent.vue?vue&type=script&lang=js"
import style0 from "./callagent.vue?vue&type=style&index=0&id=01709dff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01709dff",
  null
  
)

export default component.exports